<template>
    <div>
        <page-title :title="$t('publicOrder.title')" :showTitle="false"></page-title>
        <div class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('publicOrder.title') }}
                </div>
            </div>

            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="grid"
                            :height="600"
                            :data-source-ref="'datasource1'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable">
                    <kendo-grid-column :field="'itemName'"
                                       :title="$t('publicOrder.itemName')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'currentNumberPublicOrders'"
                                       :title="$t('publicOrder.currentNumberPublicOrders')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'currentNumberNIP'"
                                       :title="$t('publicOrder.currentNumberNIP')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'orderType'"
                                       :title="$t('publicOrder.orderType')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'status'"
                                       :title="$t('publicOrder.status')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="datetimeDisplayTemplate"
                                       :title="$t('publicOrder.termDate')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import store from '../../../store/store';
    import BtnsTemplate from "../../../components/grid/ButtonsTemplate";
    import DatetimeCellDisplayTemplate from "../../../components/grid/DatetimeCellDisplayTemplate";
    import PageTitle from '../../../components/common/PageTitle';
    import { mapGetters } from 'vuex'

    export default {
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showExportTemplateButton: {
                default: true,
                type: Boolean
            },
            showImportFromExcelButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: false,
                type: Boolean
            }
        },
        components: {
            PageTitle,
        },
        data() {
            return {
                componentName: "publicOrderPublicList",
                titleKey: 'publicOrder.title',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                schemaModelFields: {
                    itemName: {
                        name: 'itemName',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'publicOrder.itemName'
                    },
                    currentNumberPublicOrders: {
                        name: 'currentNumberPublicOrders',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'publicOrder.currentNumberPublicOrders'
                    },
                    currentNumberNIP: {
                        name: 'currentNumberNIP',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'publicOrder.currentNumberNIP'
                    },
                    orderType: {
                        name: 'orderType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'publicOrder.orderType'
                    },
                    status: {
                        name: 'status',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'publicOrder.status'
                    },
                    termDate: {
                        name: 'termDate',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'publicOrder.termDate'
                    }
                },
                rawHtml: "",
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/publicOrders/listByStatus/active`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                showUserSettingsForm: false,
            }
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            goToDetails(args) {
                this.$router.push(`/registers/publicOrder/${args.id}/details`);
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["audit-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["kendo-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },

            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "details",
                            text: "",
                            tooltip: this.$t('buttons.details.tooltipText'),
                            class: 'btn btn-info',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.goToDetails
                        }]
                    }
                };
            },
            detailsTemplate: function (dataItem) {
                if (dataItem.contractModel === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.contractModel.text === null && dataItem.contractModel.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.contractModel.textEn : dataItem.contractModel.text) + '</span>';

                return templateHtml;
            },
            datetimeDisplayTemplate: function (e) {
                return {
                    template: Vue.component(DatetimeCellDisplayTemplate.name, DatetimeCellDisplayTemplate),
                    templateArgs: {
                        dateValue: e.documentDate,
                        showShortDate: false
                    },
                };
            },
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
            $("#mainNavbar").hide();
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return store.getters.authToken;
            }
        }
    }
</script>


<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>

